module.exports = __webpack_public_path__ + "static/media/deleteHover.f91bb3fc.svg";